export const getAllLocationService = async () => {
  const URL = `/location`;  
  const query = await fetch(URL)  
  const jsonData = await query.json();  
  return jsonData;
}

export const updateLocationService = async (id, data) => {
  const URL = `/location/update/${id}`;
  const requestSetup = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const createLocationService = async (data) => {
  const URL = `/location/create`;
  const requestSetup = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}